import { UTF8 } from './UTF8';

export function uint8ArrayToString(uint8Array) {
    let result = '';

    if (typeof TextDecoder === 'undefined') {
        result = UTF8.uint8ArrayToString(uint8Array);
    } else {
        result = new TextDecoder('utf-8').decode(uint8Array);
    }

    return result;
}
